import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import '@fontsource-variable/maven-pro';
import '@fontsource/playball';
import 'leaflet/dist/leaflet.css'
import { createHead } from '@vueuse/head'
import { Auth0Instance } from './auth0';

const app = createApp(App)
const head = createHead()

app.use( Auth0Instance )
.use(router)
.use(head)

app.mount('#app')